import instance from "@/services/apiService";
import apiUrls from "@/services/apiUrls";
import store from "@/store";

const state = {
  data: null,
};

const getters = {
  loginUserInfo: (state) => state.data,
};

const actions = {
  async getLoginUserInfo({ commit }) {
    try {
      let response = await instance.get(
        `${apiUrls.WEB_CUSTOMER}?branch=${store.getters.selectedBranch.id}`
      );
      commit("getLoginUserInfo", response.data);
    } catch (error) {
      console.log(error);
    }
  },
};

const mutations = {
  getLoginUserInfo: (state, data) => (state.data = data),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
